module.exports = __webpack_public_path__ + "static/fonts/rajdhani-medium-webfont.da77462.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-medium-webfont.woff
// module id = 99
// module chunks = 0